
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════
  const CONFIG = {
    lieuCible: "Sphynx",
    splatURL: "./assets/massou/models/sphynx_cm_cut_10k.ksplat",
    meshURL: null,
    planURL: null,
    camPosX: 0,
    camPosY: 0,
    camPosZ: 1,
    camRotX: 0,
    camRotY: 0,
    camRotZ: 0,
    camTargetX: 0.2,
    camTargetY: 0,
    camTargetZ: 0,
    camMinDistance: 0.1,
    camMaxDistance: 25
  };
  // ═══════════════════════════════════════════════════════════════
  
  import { initViewer } from './spark_viewer.js';
  initViewer(CONFIG);
